import { createAction } from 'redux-actions';

export const requestGetClauseTemplatesAction = createAction('REQUEST/GET_CLAUSE_TEMPLATES');
export const requestCreateClauseTemplateAction = createAction('REQUEST/CREATE_CLAUSE_TEMPLATES');
export const requestUpdateClauseTemplateAction = createAction('REQUEST/UPDATE_CLAUSE_TEMPLATES');
export const requestDeleteClauseTemplateAction = createAction('REQUEST/DELETE_CLAUSE_TEMPLATES');
export const setClauseTemplatesQueryAction = createAction('SET/CLAUSE_TEMPLATES_QUERY');
export const setClauseTemplatesAction = createAction('SET/CLAUSE_TEMPLATES');
